module.exports = __webpack_public_path__ + "static/media/mitsubishi-vest.bfff819d.svg";